import { type ZodType, z } from "zod"

/**
 * Hems pagination wrapper. Tüm list endpoint'leri bu şekli döner.
 */
export function paginatedSchema<T>(item: ZodType<T>) {
  return z.object({
    items: z.array(item).default([]),
    pageNumber: z.number().int().default(1),
    totalPages: z.number().int().default(1),
    totalCount: z.number().int().default(0),
    hasPreviousPage: z.boolean().default(false),
    hasNextPage: z.boolean().default(false),
  })
}

export interface Paginated<T> {
  items: T[]
  pageNumber: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface PageParams {
  page?: number
  pageSize?: number
}
